module.exports = __webpack_public_path__ + "static/media/screenshot(11).cda6d7d2.jpg";